import { gql } from '@apollo/client';
import { CONTACT_FIELDS } from '../../fragments';
import { UpdateContactProps } from './contact.types';
import { ContactType } from '../../../types';

export const UPDATE_CONTACT = gql`
  ${CONTACT_FIELDS}
  mutation UpdateContact($contactId: ID!, $email: String, $phone1: String, $phone2: String) {
    updateContact(contactId: $contactId, email: $email, phone1: $phone1, phone2: $phone2) {
      ...ContactFields
    }
  }
`;

export function updateContact({
  client,
  contactId,
  email,
  phone1,
  phone2,
}: UpdateContactProps) {
  return client?.mutate<{ updateContact: ContactType }>({
    mutation: UPDATE_CONTACT,
    variables: {
      contactId,
      email,
      phone1,
      phone2,
    },
  });
}
